module.exports = __webpack_public_path__ + "static/media/add.f6491141.svg";